<template>
  <div>
    <div class="filter-table-container">
      <a class="button cta success small new-button" href="#/filter/new">CREATE NEW FILTER</a>
      <table v-if="!isMobile">
        <thead>
          <tr class="table-header">
            <th>NAME</th>
            <th>TIME RANGE</th>
            <th>TRIP DIRECTION</th>
            <th>RESERVATION STATUS</th>
            <th>GEOFENCE AREAS</th>
            <!--th>STAGING LOTS</th-->
            <th>ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          <tr class="filter" v-for="item in items">
            <td>{{ item.name }}</td>
            <td>
              <strong>{{ item.beforePickupMins }}</strong>
              <span>-</span>
              <strong>{{ item.afterPickupMins }}</strong>
              <span>minutes</span>
            </td>
            <td>
              <div v-for="direction in item.tripDirection">
                <span v-if="direction === 'p2p'">Point to Point</span>
                <span v-else>{{ capitalize(direction) }}</span>
              </div>
            </td>
            <td>
              <div v-for="status in getItemsToDisplay(item.rsvpStatus).items">{{ status }}</div>
              <div v-if="getItemsToDisplay(item.rsvpStatus).more !== null" class="more-text">
                <strong>{{ getItemsToDisplay(item.rsvpStatus).more }}</strong>
              </div>
            </td>
            <td>
              <div v-if="item.geofences.length <= 0">NONE</div>
              <div v-for="geofence in getItemsToDisplay(item.geofences).items">{{ geofence }}</div>
              <div v-if="getItemsToDisplay(item.geofences).more !== null" class="more-text">
                <strong>{{ getItemsToDisplay(item.geofences).more }}</strong>
              </div>
            </td>
            <!--td>
              <div v-if="item.stagingLots.length <= 0">NONE</div>
              <div v-for="stagingLot in getItemsToDisplay(item.stagingLots).items">{{ stagingLot }}</div>
              <div v-if="getItemsToDisplay(item.stagingLots).more !== null" class="more-text">
                <strong>{{ getItemsToDisplay(item.stagingLots).more }}</strong>
              </div>
            </td-->
            <td>
              <a :href="'#/filter/' + item.id" class="button cta xsmall">EDIT</a>
              <a href="javascript:;" class="button cta xsmall warning" @click="confirmDelete(item.id, item.name)">DELETE</a>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="card-holder" v-else>
        <loading-modal :showModal="items.length == 0" :modalMessage="'Loading'"></loading-modal>
        <div class="cards" v-for="(item, i) in items" :key="i">
          <div class="card">
            <div class="card-header">
              <div class="name">{{item.name}}</div>
              <div class="range">
                <strong>{{ item.beforePickupMins }}</strong>
                <span>-</span>
                <strong>{{ item.afterPickupMins }}</strong>
                <span>mins</span>
              </div>
            </div>
            <div class="title">
              <span class="label">Trip Direction: </span>
              <div class="value">
                <span v-for="(direction, i) in item.tripDirection" :key="i" class="comma">
                  <span v-if="direction === 'p2p'">Point to Point</span>
                  <span v-else>{{ capitalize(direction) }}</span>
                </span>
              </div>
            </div>
            <div class="title">
              <span class="label">Reservation Status: </span>
            </div>
            <div class="title">
              <div class="value">
                <span v-for="status in getItemsToDisplay(item.rsvpStatus).items" :key="status" class="comma">{{ status }}</span>
                <span v-if="getItemsToDisplay(item.rsvpStatus).more !== null" class="more-text">
                  <strong>{{ getItemsToDisplay(item.rsvpStatus).more }}</strong>
                </span>
              </div>
            </div>
            <div class="actions">
              <a :href="'#/filter/' + item.id" class="button cta xsmall">EDIT</a>
              <a href="javascript:;" class="button cta xsmall warning" @click="confirmDelete(item.id, item.name)">DELETE</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-bind:class="{ 'delete-modal-wrapper': true, show: deleteFilter.show }">
      <div class="delete-modal-content">
        <div class="delete-modal">
          <div class="message">
            Are you sure you want to delete filter <strong>{{ deleteFilter.name }}</strong>?
          </div>
          <div class="controls">
            <a class="button cta xsmall" href="javascript:;" @click="deleteFilter.show = false">NO</a>
            <a class="button warning cta xsmall" href="javascript:;" @click="executeDelete">YES</a>
          </div>
        </div>
      </div>
    </div>
    <loading-modal :showModal="deleteFilter.deleting" :modalMessage="'Deleting Filter'"></loading-modal>
  </div>
</template>

<script>
import LoadingModal from '../Partials/LoadingModal'
export default {
  name: 'filter-table',
  components: { LoadingModal },
  data () {
    return {
      deleteFilter: {
        show: false,
        id: null,
        name: null,
        deleting: false,
      },
      isMobile: false
    }
  },
  computed: {
    items () { return this.$store.state.filters.filterTable }
  },
  methods: {
    capitalize (text) {
      return (text.charAt(0).toUpperCase() + text.slice(1))
    },
    getItemsToDisplay (items) {
      let result = {
        items: [],
        more: null
      }

      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (item.name) {
          result.items.push(item.name)
        } else {
          if (item.name === null) {
            result.items.push('')
          } else {
            result.items.push(this.capitalize(item))
          }
        }

        if (i > 3) {
          break
        }
      }

      if (items.length > 5) {
        result.more = '+ ' + (items.length - 5) + ' more'
      }

      return result
    },
    confirmDelete (id, name) {
      let self = this
      self.deleteFilter.show = true
      self.deleteFilter.id = id
      self.deleteFilter.name = name
    },
    executeDelete () {
      let self = this
      self.deleteFilter.deleting = true
      self.deleteFilter.show = false
      self.$sdk.delete('/admin/filters/' + self.deleteFilter.id, {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          return
        }
        window.location.reload()
      })
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  mounted() {
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>

.filter-table-container {
  width: 1200px;
  margin: 30px auto;

  & .new-button{
    margin-bottom: 15px;
    float: right;
  }
}
table{
  border-collapse: collapse;
  width: 100%;
  overflow: auto;
  border-bottom: 1px solid rgba(0,0,0,0.2);
  padding-top: 47px;
  height: 100%;
  table-layout: fixed;
}
.table-header{
  color: #8DA0A9;
  font-size: 12px;
  border: 1px solid rgba(0,0,0,0.3);
  background-color: #f5f5f5;

  & th { padding: 5px; }
}

.filter{
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);

  & td{
    padding: 10px 10px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;
  }
}

.delete-modal-wrapper {
  position: fixed;
  top: -100%;
  opacity: 0;
  left: 0;
  display: table;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.6);
  z-index: 13;
  transition: all 250ms;

  &.show {
    top: 0;
    opacity: 1;
  }

  & .delete-modal-content {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
  }

  & .delete-modal {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    width: 300px;
    margin: 0 auto;
    padding: 15px;
    font-size: 14px;

    & .controls {
      margin-top: 10px;
    }
  }
}

.more-text {
  text-decoration: underline;
  color: #0D79F2;
}

@media only screen and (max-width: 430px) {
  .filter-table-container {
    text-align: center;
    width: 100%;
    margin: 15px auto;
    .new-button {
      float: none;
      margin-bottom: 0;
    }
  }
  .card-holder {
    margin-top: 15px;
    padding-bottom: 40px;
  }
  .cards {
    .card {
      border: 1px solid #ccc;
      margin: 0 25px;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      font-size: 12px;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 3px;
        border-bottom: 1px solid #eee;
        .name {
          font-weight: 900;
        }
      }

      .title {
        display: flex;
        align-items: center;
      }

      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-weight: 500;
        text-align: left;

        .comma ~ .comma:not(:empty):before {
            content: ", ";
        }
      }

      .actions {
        border-top: 1px solid #eee;
        padding-top: 10px;
        padding-bottom: 5px;
        margin-top: 10px;
        text-align: right;
      }
    }
  }
  .delete-modal-wrapper {
    .delete-modal {
      width: 90%;
      padding: 20px 40px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Filters/FilterTable.vue